/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, boxShadow } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : ANSWER : EMOJI : STYLES --------------- ++++++++++ */
export default theme => ({
	emoji: {
		cursor: 'pointer',
		position: 'relative',
		'& .graphic': {
			display: 'inline-block',
			textAlign: 'center',
			position: 'absolute',
			top: '50%',
			left: '50%',
			marginTop: pxToEm(-30),
			marginLeft: pxToEm(-30),
			width: pxToEm(60),
			height: pxToEm(60),
			'& .emoji': {
				// emoji comes from component itself based on switch
				fontSize: '400%',
				position: 'absolute',
				top: '-23%',
				left: '-3%',
				zIndex: '3'
			},
			// installed module (but overriding some styles here)
			'& .emoji-mart': {
				extend: boxShadow.greyLarge,
				opacity: '0',
				position: 'absolute',
				top: '-300%',
				right: '-300%',
				zIndex: '-1',
				transform: 'translate(-200%, -200%)'
			},
			'&.selected-true': {
				'& .emoji-mart': {
					opacity: '1',
					zIndex: '20',
					transform: 'translate(0%, 0%)'
				}
			}
		},
		'&:hover': {
			'& .emoji': {
				animationName: 'pulse',
	            animationDelay: '0s',
	            animationDuration: '.5s'
	        }
		}
	}
});
